import React, { Component } from "react";
import Core from "Core";
import { observer, inject } from "mobx-react";
import { ControlLabel } from "react-bootstrap";
import moment from "moment";

class StartAndEndDate extends Component {
  onStartDateChange(startDate, prevStartDate) {
    const { keepDuration } = this.props;

    if (keepDuration) {
      this.tryKeepDuration(startDate, prevStartDate);
    }

    this.resetEndDateIfInvalid(startDate);
  }

  tryKeepDuration(startDate, prevStartDate) {
    const { model, endDataMember, endDateRange } = this.props;
    if (model && endDataMember) {
      let endDate = model[endDataMember];

      if (prevStartDate && startDate && endDate) {
        const duration = moment.duration(endDate.diff(prevStartDate));
        endDate = startDate.clone().add(duration);

        if (
          endDateRange &&
          endDate.isAfter(startDate) &&
          !this.isValidEndDate(endDate)
        ) {
          endDate = startDate.endOf(endDateRange);
        }

        model[endDataMember] = endDate;
      }
    }
  }

  resetEndDateIfInvalid(startDate) {
    const { model, endDataMember } = this.props;
    if (model && endDataMember) {
      let endDate = model[endDataMember];
      if (endDate.isBefore(startDate) || !this.isValidEndDate(endDate)) {
        model[endDataMember] = startDate.clone();
      }
    }
  }

  isValidEndDate(endDate) {
    const { model, startDataMember, endDateRange } = this.props;
    let valid = true;
    if (!endDate) valid = false;
    else if (model && startDataMember) {
      const startDate = model[startDataMember];
      if (endDateRange) {
        valid = endDate.isSame(startDate, endDateRange);
      }
      if (valid) valid = endDate.isSameOrAfter(startDate);
    }
    return valid;
  }

  render() {
    const { label, model, startDataMember, endDataMember, stores } = this.props;

    return (
      <Core.Components.FormGroups.LabelValuePair
        label={label || stores.ui.translate.StartDate}
      >
        <Core.Components.Inputs.Date
          model={model}
          dataMember={startDataMember}
          onChange={this.onStartDateChange.bind(this)}
        />
        <ControlLabel style={{ paddingLeft: "0.5em", paddingRight: "0.5em" }}>
          {stores.ui.translate.EndDate}
        </ControlLabel>
        <Core.Components.Inputs.Date
          model={model}
          dataMember={endDataMember}
          isValidDate={this.isValidEndDate.bind(this)}
        />
      </Core.Components.FormGroups.LabelValuePair>
    );
  }
}

export default inject("stores")(observer(StartAndEndDate));



// WEBPACK FOOTER //
// ./src/Core/Components/FormGroups/StartAndEndDate.js